import { render, staticRenderFns } from "./DepartmentsIntroBlock.vue?vue&type=template&id=449bbac1&scoped=true&"
import script from "./DepartmentsIntroBlock.vue?vue&type=script&lang=js&"
export * from "./DepartmentsIntroBlock.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentsIntroBlock.vue?vue&type=style&index=0&id=449bbac1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449bbac1",
  null
  
)

export default component.exports